var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutobeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_9209)",
    filter: "url(#filter0_ii_2_9209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16337 0 0 7.16337 0 16C0 24.8366 7.16337 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16337 24.8366 0 16 0Z",
    fill: "#E04040"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2746 12.9127L24.2754 12.9202C24.2802 12.975 24.396 14.2774 24.3961 15.585V16.8073C24.3961 18.1149 24.2802 19.4173 24.2754 19.4722L24.2735 19.4889C24.2575 19.6173 24.1002 20.7618 23.5567 21.3504C22.9045 22.0654 22.169 22.1432 21.8154 22.1806L21.8151 22.1806C21.7813 22.1841 21.7505 22.1873 21.7231 22.1909L21.6945 22.1939C19.5269 22.351 16.2535 22.3724 16.2207 22.3725L16.2157 22.3726L16.2107 22.3725C16.0444 22.3701 12.1204 22.3117 10.8688 22.193L10.8309 22.1878C10.7928 22.1811 10.7374 22.1748 10.6729 22.1675L10.6677 22.1669C10.2459 22.1188 9.46169 22.0293 8.84149 21.353C8.27345 20.7579 8.13535 19.6099 8.12146 19.4805L8.12059 19.4723C8.11571 19.4174 8 18.1149 8 16.8073V15.585C8 14.2774 8.11571 12.9749 8.12059 12.9202L8.12246 12.9035C8.1386 12.7749 8.29572 11.6304 8.83924 11.0419C9.50072 10.3169 10.2405 10.2318 10.596 10.1909C10.601 10.1904 10.6059 10.1898 10.6108 10.1892C10.633 10.1867 10.6537 10.1843 10.6728 10.1817L10.7017 10.1787C12.8888 10.0217 16.1623 10.0002 16.1951 10.0001L16.198 10L16.2009 10.0001C16.2336 10.0002 19.5071 10.0217 21.6747 10.1787L21.7034 10.1817C21.7278 10.1849 21.755 10.1881 21.7848 10.1914C22.1444 10.2322 22.8922 10.3172 23.5518 11.0168C24.1225 11.6117 24.2607 12.7812 24.2746 12.9127ZM15.0991 13.4808L18.7214 15.4554C18.9358 15.5723 19.0684 15.796 19.0675 16.0394C19.0665 16.2828 18.9323 16.5055 18.7172 16.6208L15.0948 18.5614C14.9954 18.6148 14.8873 18.6413 14.7795 18.6413C14.6618 18.6413 14.5443 18.6097 14.4384 18.5466C14.2355 18.4258 14.1144 18.2131 14.1144 17.9777V14.0623C14.1144 13.8258 14.2362 13.6127 14.4405 13.492C14.6446 13.3715 14.8908 13.3673 15.0991 13.4808Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2_9209",
    x: 0,
    y: -2,
    width: 32,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_9209"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2_9209",
    result: "effect2_innerShadow_2_9209"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_9209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutobeIcon);
export default __webpack_public_path__ + "static/media/youtobe_icon.6ff20c0074677a420bf443611daa4ce5.svg";
export { ForwardRef as ReactComponent };